module.exports = __webpack_public_path__ + "static/media/coding-guide-data-science-interviews.36c2341c.md";